/**
 * Sélection multiple de la section « Public » de la modale des vues.
 *
 * La logique est sortie du composant pour être testable sans monter Vue,
 * comme les modules `mergeSelection` / `directoryTable` du carnet d'adresses.
 * Toutes les fonctions sont pures : elles renvoient un nouveau tableau.
 */

/** Ajoute ou retire une vue de la sélection. */
export const toggleSelection = (selectedIds, id) =>
  selectedIds.includes(id)
    ? selectedIds.filter((item) => item !== id)
    : [...selectedIds, id]

/**
 * Ajoute les vues actuellement affichées à la sélection.
 *
 * Le cumul est volontaire : ce qui a été coché sous une recherche précédente
 * reste sélectionné quand le terme change, sinon filtrer ferait silencieusement
 * perdre des vues à l'utilisateur. Le compteur du bouton d'abonnement le rappelle.
 */
export const selectAll = (selectedIds, visibleIds) => [
  ...new Set([...selectedIds, ...visibleIds])
]

/** Vrai si toutes les vues affichées sont déjà cochées (liste vide = faux). */
export const isAllSelected = (selectedIds, visibleIds) =>
  visibleIds.length > 0 && visibleIds.every((id) => selectedIds.includes(id))

/**
 * Purge la sélection des vues qui ne sont plus proposées : une vue abonnée
 * entre-temps, ou supprimée, ne doit jamais rester cochée.
 */
export const keepAvailable = (selectedIds, availableIds) =>
  selectedIds.filter((id) => availableIds.includes(id))

/**
 * Garde anti-doublon (critère d'acceptation n°7) : on ne poste que les vues
 * que l'utilisateur ne suit pas encore, même si l'interface en a laissé passer
 * une déjà suivie.
 */
export const subscribableIds = (selectedIds, subscribedIds) =>
  selectedIds.filter((id) => !subscribedIds.includes(id))

/** Vues dont l'abonnement a échoué : elles restent cochées pour un réessai. */
export const failedIds = (postedIds, results) =>
  postedIds.filter((_, index) => results[index]?.status === 'rejected')
